import React, { Component } from 'react';
import PropTypes from "prop-types";
import { NoticeBorder, NoticeContainer, NoticeContent } from '../styles';

class Notice extends Component {
  render() {
    return (
      <NoticeBorder>
        <NoticeContainer
          message={(
            <NoticeContent >
              { this.props.noticeContent ? 
              <div dangerouslySetInnerHTML={{__html: this.props.noticeContent.confirmationNotice.field_notice_content}}></div> 
              : <div>Please note, once the assets are received by Vanguard Charitable, contributions of securities take approximately one business week to settle and be reflected in the balance of your philanthropic account. You can track the contribution progress by clicking Contributions > Contribution Activity and choosing the date of your contribution.</div>
              }
              </NoticeContent>
          )}> </NoticeContainer>
      </NoticeBorder>
    );
  }
}

Notice.propTypes = {
  noticeContent: PropTypes.object
}

export default Notice;
